import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import TransunionLogo from "../../Assets/images/logo_transunion.png";
import { ApplicationState } from "../../store";
import { getCreditLockStatus, updateCreditStatusLock, updateCreditStatusUnlock } from "../../store/service";
import { DialogComponent } from "../common/DialogComponent";
import { Notification } from "../common/Notification";
import CreditFreezeDialog from "../Dialogs/CreditFreezeDialog";

const CreditLockCard = ({ authData }: any) => {
    const history = useHistory();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [isFreeze, setIsFreeze] = useState(false);
    const csidAuthStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus["auth-status"] : ""
    );
    const [status, setStatus] = useState("");

    const fetchCreditLockStatus = () => {
        if (csidAuthStatus && csidAuthStatus.trim().toUpperCase() === "AUTHENTICATED") {
            getCreditLockStatus().then((res) => {
                if (res.getStatusResponse && res.getStatusResponse.actionData) {
                    setStatus(res.getStatusResponse.actionData.statusCode);
                }
            });
        }
    };

    useEffect(fetchCreditLockStatus, [csidAuthStatus]);

    const changeStatus = () => {
        if (status === "LOCKED") {
            setLoading(true);
            updateCreditStatusUnlock()
                .then((res) => {
                    setLoading(false);
                    if (!res.hasError) {
                        setStatus("UN_LOCKED");
                    } else {
                        Notification({
                            type: "error",
                            title: "Credit Lock Status",
                            message: "We were unable to unlock your credit report. Please try again.",
                            duration: 5,
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Credit Lock Status",
                        message: err.errorMessage,
                        duration: 5,
                    });
                });
        } else if (status === "UN_LOCKED" || status === "NO_LOCK_OR_FREEZE") {
            setLoading(true);
            updateCreditStatusLock()
                .then((res) => {
                    setLoading(false);
                    if (!res.hasError) {
                        setStatus("LOCKED");
                    } else {
                        Notification({
                            type: "error",
                            title: "Credit Lock Status",
                            message: "We were unable to lock your credit report. Please try again.",
                            duration: 5,
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Credit Lock Status",
                        message: err.errorMessage,
                        duration: 5,
                    });
                });
        } else {
            setIsFreeze(true);
        }
    };

    const closeFreezeDialog = () => {
        setIsFreeze(false);
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            changeStatus();
        }
    }

    return status ? (
        <React.Fragment>
            <div className={`${status && loading ? "loading" : ""} box box-border-top`}>
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text">
                            <h3 className="box-title">{tLang("dashboard.creditLockWidget.title")}</h3>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    <div className="row credit-lock-row-dashboard">
                        <div className="box-title-icon" aria-hidden="false">
                            <img src={TransunionLogo} alt="TransUnion Logo" className="tu-logo" />
                        </div>

                        <div
                            className={`${status === "LOCKED" ? "btn-credit-lock-success" : "btn-credit-unlock"}`}
                            onClick={changeStatus}
                            tabIndex={0}
                            role="button"
                            onKeyDown={handleKeyPress}
                            aria-label={status === "LOCKED" ? "Locked" : "Unlocked"}
                        >
                            {status !== "LOCKED" && (
                                <span className="btn-icon">
                                    <em className="las la-lock-open"></em>
                                </span>
                            )}
                            <button className={`btn-default ${status === "LOCKED" ? "btn-locked-text" : ""}`} aria-label={status === "LOCKED" ? "Locked" : "Unlocked"} style={{ padding: "0.25rem" }} tabIndex={-1} aria-hidden="false">
                                <h5>{status === "LOCKED" ? "Locked" : "Unlocked"}</h5>
                            </button>
                            {status === "LOCKED" && (
                                <span className="btn-icon">
                                    <em className="las la-lock"></em>
                                </span>
                            )}
                        </div>
                    </div>
                    <p className="text-align-center">
                        <a
                            className="btn-default btn-secondary-outline bit-btn"
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                history.push("/credit/lock");
                            }}
                            id="btn-leave-feedback"
                            target="_blank"
                        >
                            <span className="btn-text">{tLang("dashboard.creditLockWidget.buttonText")}</span>
                        </a>
                    </p>
                </div>
            </div>
            <div className="credit-freeze-dialog">
                {isFreeze && (
                    <DialogComponent dialogId="dialog-credit-freeze" title="Credit Freeze Dialog" closeDialog={closeFreezeDialog}>
                        <CreditFreezeDialog closeDialog={closeFreezeDialog} />
                    </DialogComponent>
                )}
            </div>
        </React.Fragment>
    ) : (
        <></>
    );
};

export default CreditLockCard;
